{
  "line.carriage.name": "Carriage charges",
  "line.carriage.description": "Carriage from {origin} to {destination}, delivered on {delivered_on}.",
  "note.cash_on_delivery": "Cash on delivery collected at delivery: {amount} {currency} (CMR box 15). This amount is not part of this invoice.",
  "document.proof_of_delivery": "Electronic proof of delivery (ePOD)"
}
